import { render, staticRenderFns } from "./VodFluxHitRatey.vue?vue&type=template&id=315b9455&scoped=true"
import script from "./VodFluxHitRatey.vue?vue&type=script&lang=js"
export * from "./VodFluxHitRatey.vue?vue&type=script&lang=js"
import style0 from "./VodFluxHitRatey.vue?vue&type=style&index=0&id=315b9455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b9455",
  null
  
)

export default component.exports